import Button from "components/base/Button";
import { Input } from "components/base/Form";
import Page from "components/base/Page";
import QRCode from "qrcode.react";
import { useRef, useState } from "react";
import { downloadImageFromCanvas, downloadSvg } from "./utils";

const QRCodePage = () => {
  const [string, setString] = useState("https://waboba.com");
  const qrcodeContainerRef = useRef();

  return (
    <Page title="QRCode Generator" className="h-screen">
      <div className="p-4 lg:p-6 flex flex-1 items-center justify-center">
        <div className="w-64 md:w-1/3">
          <Input
            autoFocus
            placeholder="Input any string here and you will get a qrcode for it."
            className="w-full text-center"
            value={string}
            onChange={(e) => setString(e.target.value)}
          />
          <div ref={qrcodeContainerRef} className="my-6 flex justify-center">
            <QRCode renderAs="svg" value={string} size={300} />
            <QRCode
              renderAs="canvas"
              value={string}
              size={300}
              className="hidden"
            />
          </div>
          <div className="mt-4 flex justify-center space-x-4">
            <Button
              title="Download SVG"
              onClick={() =>
                downloadSvg(
                  qrcodeContainerRef.current.children[0],
                  string + "-shorten-link",
                )
              }
            >
              Download SVG
            </Button>
            <Button
              onClick={() =>
                downloadImageFromCanvas(
                  qrcodeContainerRef.current.children[1],
                  string + "-shorten-link",
                  "png",
                )
              }
            >
              Download PNG
            </Button>
            <Button
              onClick={() =>
                downloadImageFromCanvas(
                  qrcodeContainerRef.current.children[1],
                  string + "-shorten-link",
                  "jpg",
                )
              }
            >
              Download JPG
            </Button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default QRCodePage;
